import request from "@/util/request";
import util from "@/util/util";
class print {
  // 待打印列表
  waiting(self) {
    return new Promise((resolve, reject) => {
      let start_time = util.getlimiTime(39)+ ' 00:00:00' ;
      let end_time = util.getlimiTime(0)+ ' 23:59:59';
      if(self.searchMsg.date == null){
        self.searchMsg.date = ['','']
      }
      if (self.searchMsg.date[0] && self.searchMsg.date[1]) {
        // start_time = self.searchMsg.date[0] ? util.formatTime(self.searchMsg.date[0],'yyyy-MM-dd') + ' 00:00:00' : '';
        // end_time = self.searchMsg.date[1] ? util.formatTime(self.searchMsg.date[1],'yyyy-MM-dd') + ' 23:59:59' : '';
        start_time = self.searchMsg.date[0] ? self.searchMsg.date[0] + ' 00:00:00' : '';
        end_time = self.searchMsg.date[1] ? self.searchMsg.date[1] + ' 23:59:59' : '';
      }
      const jgsort = util.jgsort(self.searchMsg.sort);
      request
        .post(self, {
          action: "kdyserver.order.queryOrderWaitPrint",
          data: {
            account_id: util.getCookie("account_id"),
            current_page: self.currPage,
            key_word: self.searchMsg.key_word,
            order_status:self.searchMsg.order_status,
            mail_get_type:self.searchMsg.mail_get_type,  // 运单号获取 0:全部，1-已获取，2-未获取，3-已失效
            order_source:self.searchMsg.order_source,  //0-全部， 101-寄快递创建， 102-电脑导入， 103-邀请下单
            page_size: self.page_size,
            start_time: start_time,
            end_time: end_time,
            printer:self.searchMsg.printer,
            sort: jgsort[1], 
            order_by_column:jgsort[0], 
            service_type:self.searchMsg.service_type,
            express_type:self.searchMsg.express_type,
            order_creator:self.searchMsg.order_creator,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 已打印列表
  already(self) {
    return new Promise((resolve, reject) => {
      let start_time = util.getlimiTime(39)+ ' 00:00:00';
      let end_time = util.getlimiTime(0)+ ' 23:59:59';
      if(self.searchMsg.date == null){
        self.searchMsg.date = ['','']
      }
      if (self.searchMsg.date[0] && self.searchMsg.date[1]) {
        start_time = self.searchMsg.date[0] ? self.searchMsg.date[0] + ' 00:00:00' : '';
        end_time = self.searchMsg.date[1] ? self.searchMsg.date[1] + ' 23:59:59' : '';
      }
      const jgsort = util.jgsort(self.searchMsg.sort);
      let queryData = {
        account_id: util.getCookie("account_id"),
        current_page: self.currPage,
        key_word: self.searchMsg.key_word,
        mail_order_status:self.searchMsg.mail_order_status,
        order_status:self.searchMsg.order_status,  // 运单号获取 0:全部，1-已获取，2-未获取，3-已失效
        order_source:self.searchMsg.order_source,  //0-全部， 101-寄快递创建， 102-电脑导入， 103-邀请下单
        page_size: self.page_size,
        printer:self.searchMsg.printer,
        sort: jgsort[1], 
        order_by_column:jgsort[0], 
        service_type:self.searchMsg.service_type,
        express_type:self.searchMsg.express_type,
        order_creator:self.searchMsg.order_creator,
      }
      if(self.searchMsg.timeType == 1){
        queryData.start_time_print = start_time;
        queryData.end_time_print = end_time;
      }else{
        queryData.start_time = start_time;
        queryData.end_time = end_time;
      }
      request
        .post(self, {
          action: "kdyserver.order.queryOrderPrinted",
          data: queryData 
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 运单列表
  orders(self) {
    return new Promise((resolve, reject) => {
      let start_time = util.getlimiTime(14)+ ' 00:00:00';
      let end_time = util.getlimiTime(0)+ ' 23:59:59';
      if(self.searchMsg.date == null){
        self.searchMsg.date = ['','']
      }
      if (self.searchMsg.date[0] && self.searchMsg.date[1]) {
        start_time = self.searchMsg.date[0] ? self.searchMsg.date[0] + ' 00:00:00' : '';
        end_time = self.searchMsg.date[1] ? self.searchMsg.date[1] + ' 23:59:59' : '';
      }
      // const jgsort = util.jgsort(self.searchMsg.sort);
      let queryData = {
        account_id: util.getCookie("account_id"),
        current_page: self.currPage,
        key_word: self.searchMsg.key_word,
        mail_order_status:self.searchMsg.mail_order_status,  // 运单号获取 0:全部，1-已获取，2-未获取，3-已失效
        page_size: self.page_size,
        service_type:self.searchMsg.service_type,
        express_type:self.searchMsg.express_type,
      }
     
        queryData.start_time = start_time;
        queryData.end_time = end_time;
      request
        .post(self, {
          action: "kdyserver.order.mailorderlist",
          data: queryData 
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
   // 获取运单统计数据
  signStatistics(self) {
     return new Promise((resolve, reject) => {
      let start_time = util.getlimiTime(14)+ ' 00:00:00';
       let end_time = util.getlimiTime(0) + ' 23:59:59';
       if (self.searchMsg.date[0] && self.searchMsg.date[1]) {
        start_time = self.searchMsg.date[0] ? self.searchMsg.date[0] + ' 00:00:00' : '';
        end_time = self.searchMsg.date[1] ? self.searchMsg.date[1] + ' 23:59:59' : '';
      }
      request
        .post(self, {
          action: "kdyserver.order.logistics.statistics",
          data: {
            account_id: util.getCookie("account_id"),
            start_time: start_time,
            end_time: end_time,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //打印数据预处理
  prePrintData(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.print.prePrintOrder",
          data: {
            account_id: util.getCookie("account_id"),
            order_ids: orderIds,
            template_platform:"lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //处理打印数据
  printData(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.print.printOrder",
          data: {
            account_id: util.getCookie("account_id"),
            order_ids: orderIds,
            template_platform:"lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 临时包裹获取打印数据
  lsprintData(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.print.prePrintPcImportTempOrder",
          data: {
            account_id: util.getCookie("account_id"),
            ids: orderIds.join(","),
            template_platform:"lodop",
            pri:self.ysBill ? 'PRI' : 'PT',
            value_add_type:self.value_add_type ? 'topay' : 'pt',
            source:8
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 取消订单数据
  cancelData(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.cancelorder",
          data: {
            account_id: util.getCookie("account_id"),
            order_id: orderIds,
            // template_platform:"lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 取消订单数据
  delData(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.deleteOrderByOrderId",
          data: {
            account_id: util.getCookie("account_id"),
            order_id: orderIds,
            // template_platform:"lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //批量取消订单数据
  batchcancel(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.batchcancel",
          data: {
            account_id: util.getCookie("account_id"),
            order_ids: orderIds,
            // template_platform:"lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //批量删除订单数据
  batchdel(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.batchDeleteOrder",
          data: {
            account_id: util.getCookie("account_id"),
            order_ids: orderIds,
            // template_platform:"lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 提交给协议快递员
  sumbKdy(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.submitYwy",
          data: {
            account_id: util.getCookie("account_id"),
            order_ids: orderIds,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 临时包裹提交给协议快递员
  lssumbKdy(self,orderIds) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.submitPcTempOrderToYwy",
          data: {
            account_id: util.getCookie("account_id"),
            ids: orderIds.join(","),
            pri:self.ysBill ? 'PRI' : 'PT',
            value_add_type:self.value_add_type ? 'topay' : 'pt',
            source:7
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 导出待/已打印订单
  downloadFile(self,type) {
    let searchMsg = self.searchMsg
    let start_time = util.getlimiTime(90)+ ' 00:00:00';
    let end_time = util.getlimiTime(0)+ ' 23:59:59';
    if(self.searchMsg.date == null){
      self.searchMsg.date = ['','']
    }
    if (searchMsg.date[0] && searchMsg.date[1]) {
      start_time = self.searchMsg.date[0] ? self.searchMsg.date[0] + ' 00:00:00' : '';
      end_time = self.searchMsg.date[1] ? self.searchMsg.date[1] + ' 23:59:59' : '';
    }
    const jgsort = util.jgsort(self.searchMsg.sort);
    let commondata = {
          account_id: util.getCookie('account_id'),
          "key_word": searchMsg.key_word, //key值,非必传,和key_type一起传有效,单个无效,值任意,查询时都是模糊匹配
          "order_type":type,  
          "mail_get_type":self.searchMsg.mail_get_type,  // 运单号获取 0:全部，1-已获取，2-未获取，3-已失效
          "order_source":self.searchMsg.order_source,  //0-全部， 101-寄快递创建， 102-电脑导入， 103-邀请下单
          "order_status":self.searchMsg.order_status,
          "printer":self.searchMsg.printer,
          "sort": jgsort[1], 
          "order_by_column":jgsort[0],   
          "service_type":self.searchMsg.service_type,  
          "mail_order_status":self.searchMsg.mail_order_status  
    }
    if(type == 1){
      // commondata.mail_order_status = self.searchMsg.mail_order_status; 
      if(self.searchMsg.timeType == 1){
        commondata.start_time_print = start_time;
        commondata.end_time_print = end_time;
      }else{
        commondata.start_time = start_time;
        commondata.end_time = end_time;
      }
    }else{
      commondata.end_time = end_time
      commondata.start_time = start_time
    }
    console.log(commondata)
    return new Promise((resolve, reject) => {
      request.download(self, {
        action: "/file/downloadOrders",
        data:commondata
      }).then(res => { resolve(res) })
    })
  }
  // 获取物流信息
  logistics(self,mailNo) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.mail.trackingLogistics",
          option:true,
          data: {
            account_id: util.getCookie("account_id"),
            mail_no: mailNo,
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.code == 200) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 面单不足提醒
  ywyauthorize(){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.mail.ywyauthorize.warn",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.code == 200) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  data: res.body.data
                }
              });
            }
          }
        });
    });
  }
  // 获取运单号
  getmaiNo(order_id){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.getMailNoByOrderId",
          data: {
            order_id:order_id
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.code == 200) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  data: res.body.data
                }
              });
            }
          }
        });
    });
  }
}
export default new print()